import { Component, Inject, Input, OnInit } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { UtilitiesService } from "app/services/utilities/utilities.service";

@Component({
  selector: 'act-dialog-taxes-fees',
  templateUrl: './dialog-taxes-fees.component.html',
  styleUrls: ['./dialog-taxes-fees.component.scss']
})
export class DialogTaxesFeesComponent implements OnInit {

  constructor(
    @Inject(MD_DIALOG_DATA)
    public data: any,
    public dialogRef: MdDialogRef<DialogTaxesFeesComponent>,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.utilitiesService.unlockBody();
    this.utilitiesService.unlockBodyBackdrop();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cart/dialog-taxes-fees/dialog-taxes-fees.component.ts